if (!customElements.get('charity-tooltip')) {
  customElements.define(
    'charity-tooltip',
    class CharityTooltip extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.charity-more-details');
        this.tooltip = this.querySelector('.charity-details');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.openedByHover = false;
        this.onReposition = this.positionTooltip.bind(this);

        if (!this.button || !this.tooltip) return;

        this.button.addEventListener('click', this.toggle.bind(this));
        this.button.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.button.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        this.tooltip.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.addEventListener('keydown', this.onKeydown.bind(this));
        document.addEventListener('click', this.onOutsideClick.bind(this));
      }

      get isOpen() {
        return this.button.getAttribute('aria-expanded') === 'true';
      }

      open() {
        this.button.setAttribute('aria-expanded', 'true');
        this.tooltip.hidden = false;
        this.positionTooltip();
        window.addEventListener('resize', this.onReposition);
      }

      close() {
        this.button.setAttribute('aria-expanded', 'false');
        this.tooltip.hidden = true;
        this.resetPosition();
        window.removeEventListener('resize', this.onReposition);
      }

      resetPosition() {
        this.tooltip.style.removeProperty('--charity-shift');
        this.tooltip.style.removeProperty('--charity-caret-right');
      }

      positionTooltip() {
        if (this.tooltip.hidden) return;

        this.resetPosition();

        // Measure after layout with the default right-aligned placement.
        const rect = this.tooltip.getBoundingClientRect();
        const margin = 16;
        const overflowLeft = margin - rect.left;
        const overflowRight = rect.right - (window.innerWidth - margin);

        let shift = 0;
        if (overflowLeft > 0) shift = overflowLeft;
        else if (overflowRight > 0) shift = -overflowRight;

        if (shift === 0) return;

        this.tooltip.style.setProperty('--charity-shift', `${shift}px`);
        // Keep the caret under the trigger after shifting the panel.
        this.tooltip.style.setProperty('--charity-caret-right', `calc(0.8rem + ${shift}px)`);
      }

      toggle(event) {
        event.preventDefault();
        // A click immediately after a hover-open (desktop) is the same physical
        // interaction, not a deliberate re-toggle - ignore it once.
        if (this.openedByHover) {
          this.openedByHover = false;
          return;
        }
        this.isOpen ? this.close() : this.open();
      }

      onMouseEnter() {
        if (!this.mqlTablet.matches) return;
        this.openedByHover = true;
        this.open();
      }

      onMouseLeave(event) {
        if (!this.mqlTablet.matches) return;
        if (this.contains(event.relatedTarget)) return;
        this.openedByHover = false;
        this.close();
      }

      onFocusOut(event) {
        if (this.contains(event.relatedTarget)) return;
        this.close();
      }

      onKeydown(event) {
        if (event.key === 'Escape' && this.isOpen) {
          this.close();
          this.button.focus();
        }
      }

      onOutsideClick(event) {
        if (this.contains(event.target)) return;
        this.close();
      }
    }
  );
}
